import { Link } from "react-router-dom";
import { formatDateWithTime, getFirstLetterOfName } from "../Utils";
import { paths } from "../Constant/paths";

//hover-box p-3 rounded-2 shadow bg-white z-12

export const UserHover = ({ user, isOverlayTrigger }) => {
  return (
    <div
      className={`hover-box p-3 rounded-2 bg-white shadow ${
        isOverlayTrigger ? "bg-white z-12" : ""
      }`}
    >
      <div className={isOverlayTrigger ? "" : ""}>
        <div className="new-avater d-flex w-100">
          <div className="mb-2 position-relative">
            <div className="me-2 w-24 h-24 rounded-circle bg-slate-200 position-relative overflow-hidden">
              {user.photoURL ? (
                <img
                  src={user.photoURL}
                  alt={`${user.firstName}${user.lastName}`}
                  className="w-100 h-100 object-fit-cover"
                />
              ) : (
                getFirstLetterOfName(user)
              )}
            </div>
          </div>

          <div className="new-av-details w-100">
            <h4 className="text-sm font-semibold">
              {user.firstName} {user.lastName}
            </h4>

            <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1 font-medium">
              <li className="d-flex align-items-center">
                <i className="bx bx-user me-1"></i> {user.type}
              </li>
              <li>
                <i className="bx bx-envelope me-1"></i> {user.email}
              </li>
              <li>
                <i className="bx bx-time me-1"></i>
                {/* 6:45 local time */}
                {formatDateWithTime(`${new Date()}`)}
              </li>
            </ul>

            <div className="d-flex gap-1 mt-3">
              <Link
                to={`${paths.common.viewProfile}/${user.gid}`}
                className="btn btn-mini btn-light text-nowrap"
              >
                View Profile
              </Link>
              <button
                type="button"
                className="btn btn-mini btn-dark text-nowrap"
              >
                Send Message
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
